// extracted by mini-css-extract-plugin
export default {"offerWrapper":"Offer_offerWrapper__hOpFd","offerDivider":"Offer_offerDivider__E8P15"};